import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';
import { resolveAccess } from '@bay-ui/utilities/access';
import { ACCOUNT_APP_ID } from '../../lib/environment.js';

// bay-ui has no jwt-decode, so the cookie read stays app-side.
//TODO: Maybe refactor this to use the global state instead of cookies
const userFromJwtCookie = () => {
	const bayToken = Cookies.get('bayToken');
	if (!bayToken) return null;
	try {
		return jwt_decode(bayToken)?.session?.user ?? null;
	} catch {
		return null;
	}
};

export const getAccess = (user) =>
	resolveAccess(user ?? userFromJwtCookie(), { appId: ACCOUNT_APP_ID });
